export default __webpack_public_path__ + "static/media/orbitz.02390101.svg";